import React from 'react';
import PropTypes from 'prop-types';
import ConfirmationAmount from './ConfirmationAmount';
import ConfirmationAmountGiftAid from './ConfirmationAmountGiftAid';
import { BodyText } from '@paypalcorp/pp-react';
import { isCampaigns } from '../utility/productIntegrationUtils';

const ConfirmationMessage = ({
  yourDonation,
  giftaidFlag,
  extraDonateAmount,
  giftAid,
  orgSuccess,
}) => {
  return (
    <div className="confirmation_header" role="text">
      <ConfirmationAmount message={yourDonation} />
      {giftaidFlag && (
        <ConfirmationAmountGiftAid
          extraDonateAmount={extraDonateAmount}
          giftAid={giftAid}
        />
      )}
      {isCampaigns() && orgSuccess && (
        <BodyText className="text-center" style={{ margin: '24px auto 72px' }}>
          {orgSuccess}
        </BodyText>
      )}
    </div>
  );
};

ConfirmationMessage.propTypes = {
  yourDonation: PropTypes.object,
  giftaidFlag: PropTypes.bool,
  extraDonateAmount: PropTypes.string,
  giftAid: PropTypes.string,
  orgSuccess: PropTypes.object,
};

export default ConfirmationMessage;
